import {
  ColumnLayout,
  Box,
  Button,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../default-constants";
import { LABELS } from "./constants";
import { useNavigate } from "react-router-dom";

interface IFooter {
  examinationApplicationNo: string;
  isNttF: boolean;
}

/**
 * フッターのボタン群
 */
const Footer = (props: IFooter) => {
  const { examinationApplicationNo, isNttF } = props;
  const navigator = useNavigate();

  /**
   * 戻るボタンを押したときの処理.
   */
  const backOnClick = () =>
    navigator(`/examination-status?isBackFromDetail=true`);

  /**
   * 審査結果取扱ボタンを押したときの処理.
   */
  const toExaminationResultHandlingOnClick = () =>
    navigator(`/examination-result-handling/${examinationApplicationNo}`);

  return (
    <ColumnLayout columns={2}>
      <Box float={"left"}>
        <Button formAction={"none"} variant={"link"} onClick={backOnClick}>
          {COMMON_LABELS.BTNS.BACK}
        </Button>
      </Box>
      <Box float={"right"}>
        {!isNttF ? (
          <SpaceBetween direction={"horizontal"} size={"l"}>
            <Button onClick={toExaminationResultHandlingOnClick}>
              {LABELS.EXAMINATION_RESULT_HANDLING}
            </Button>
          </SpaceBetween>
        ) : (
          <></>
        )}
      </Box>
    </ColumnLayout>
  );
};

export default Footer;
